import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useCallback, useEffect, useState } from 'react';
import { shape, string } from 'prop-types';
import { getCurrentPath, routePush } from '@magalu/mixer-utils';
import { Select } from './SortSelect.styles';
import { sortTypes, DEFAULT_FILTER_LENGTH, DEFAULT_SORT_OPTIONS_LENGTH } from './constants';
var SortSelect = function SortSelect(_ref) {
  var _structure$route;
  var staticProps = _ref["static"],
    structure = _ref.structure;
  var selectLabel = staticProps.selectLabel;
  var selectedOption = (_structure$route = structure.route) == null ? void 0 : _structure$route.sortType;
  var _ref2 = (structure == null ? void 0 : structure.route) || {},
    filters = _ref2.filters;
  var _useState = useState(filters),
    _useState2 = _slicedToArray(_useState, 2),
    currentFilters = _useState2[0],
    setCurrentFilters = _useState2[1];
  var _useState3 = useState(sortTypes),
    _useState4 = _slicedToArray(_useState3, 2),
    sortOptions = _useState4[0],
    setSortOptions = _useState4[1];
  var handleChange = useCallback(function (sortOption) {
    var sort = sortTypes.some(function (sortType) {
      return sortType.value === sortOption;
    });
    if (sort) {
      var path = getCurrentPath({
        page: 1,
        sortType: sortOption
      });
      routePush({
        path: path,
        spa: true
      });
    }
  }, []);
  var getSortedOptions = function getSortedOptions() {
    return sortOptions.map(function (sortOption) {
      if (sortOption.value === selectedOption) {
        return _extends({}, sortOption, {
          selected: true
        });
      }
      return sortOption;
    });
  };
  var hasFiltersChanged = function hasFiltersChanged() {
    var newFilters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var filtersChanged = JSON.stringify(currentFilters) !== JSON.stringify(newFilters);
    var shouldUpdateSortOptions = newFilters.length > DEFAULT_FILTER_LENGTH && sortTypes.length > DEFAULT_SORT_OPTIONS_LENGTH;
    return filtersChanged && shouldUpdateSortOptions;
  };
  useEffect(function () {
    setCurrentFilters(filters);
    if (hasFiltersChanged(filters)) {
      setSortOptions(sortTypes.slice(0, -2));
    } else if (sortOptions.length === DEFAULT_SORT_OPTIONS_LENGTH && filters.length === DEFAULT_FILTER_LENGTH) {
      setSortOptions(sortTypes);
    }
  }, [filters]);
  return React.createElement(Select, {
    id: "sort-review",
    desktopMode: true,
    textLabel: selectLabel,
    options: getSortedOptions(),
    onChange: handleChange
  });
};
process.env.NODE_ENV !== "production" ? SortSelect.propTypes = {
  "static": shape({
    selectLabel: string
  }),
  structure: shape({
    route: shape({
      sortType: string
    })
  })
} : void 0;
SortSelect.defaultProps = {
  "static": {
    selectLabel: 'Ordenar'
  },
  structure: {
    route: {
      filters: []
    }
  }
};
SortSelect.ssr = true;
export default SortSelect;